<ng-container *ngIf="tickersWithNoRating?.length">
	<div class="text-16">
		<span dcrHTMLKey="ESG_NO_RATING_HOLDINGS_TEXT" data-cy="esg-no-ratings-text">Holdings without an MSCI ESG Rating include: </span>
		<span data-cy="esg-no-ratings-data"> {{ tickersWithNoRating.join(', ') }}</span>
	</div>
</ng-container>
